(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var enabled = !document.body.classList.contains('no-motion') && !reduced;
  if (!enabled) {
    // Senza movimento i contatori mostrano subito il valore finale.
    document.querySelectorAll('[data-count-to]').forEach(function (el) {
      el.textContent = formatCount(el, parseFloat(el.getAttribute('data-count-to')));
    });
    return;
  }

  // --- Contatori animati -----------------------------------------------------
  function formatCount(el, value) {
    var decimals = parseInt(el.getAttribute('data-decimals'), 10) || 0;
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    var n = value.toLocaleString('it-IT', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
    return prefix + n + suffix;
  }

  function runCounter(el) {
    var target = parseFloat(el.getAttribute('data-count-to')) || 0;
    var duration = parseInt(el.getAttribute('data-duration'), 10) || 1600;
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      // easeOutCubic
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = formatCount(el, target * eased);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = formatCount(el, target);
    }
    requestAnimationFrame(step);
  }

  var counters = document.querySelectorAll('[data-count-to]');
  if (counters.length && 'IntersectionObserver' in window) {
    var cObs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          runCounter(entry.target);
          cObs.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );
    counters.forEach(function (el) {
      el.textContent = formatCount(el, 0);
      cObs.observe(el);
    });
  } else {
    counters.forEach(function (el) {
      el.textContent = formatCount(el, parseFloat(el.getAttribute('data-count-to')));
    });
  }

  // --- Parallax leggero ------------------------------------------------------
  // Elementi con data-parallax="0.15": si spostano di una frazione dello scroll
  // quando sono in viewport. Solo transform, nessuno spostamento del layout.
  var parallax = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  if (parallax.length) {
    var ticking = false;
    var update = function () {
      var vh = window.innerHeight;
      parallax.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var factor = parseFloat(el.getAttribute('data-parallax')) || 0.12;
        // -1..1 rispetto al centro viewport
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        var shift = Math.max(-60, Math.min(60, progress * factor * 100));
        el.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)';
      });
      ticking = false;
    };
    var onScroll = function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }
})();
